module.exports = __webpack_public_path__ + "assets/d5f34bce9fd8e1a09d7c7c8c2f4f5b39.mp3";